import { MenuItem } from '@/types/menu';

export const appMenu: MenuItem[] = [
  {
    label: 'Dashboard',
    slug: 'dashboard',
    path: '/',
    pathType: 'internal',
    pill: {},
    media: {},
    description: '',
    hasSubMenu: false,
    subMenu: [],
    publicAccess: true,
  },
  {
    label: 'Sales',
    slug: 'sales',
    path: '#',
    pathType: 'internal',
    pill: {},
    media: {},
    description: '',
    hasSubMenu: true,
    subMenu: [
      {
        label: 'Customers',
        slug: 'customers',
        path: '/customers',
        pathType: 'internal',
        pill: {},
        media: {},
        description: '',
        requiresPermission: {
          resource: 'customers',
          action: 'read',
        },
      },
      {
        label: 'Sales Orders',
        slug: 'orders',
        path: '/orders',
        pathType: 'internal',
        pill: {},
        media: {},
        description: '',
        requiresPermission: {
          resource: 'sales_order',
          action: 'read',
        },
      },
      {
        label: 'Promotions',
        slug: 'discount',
        path: '/discount',
        pathType: 'internal',
        pill: {},
        media: {},
        description: '',
        requiresPermission: {
          resource: 'discounts',
          action: 'read',
        },
      },
      {
        label: 'Transactions',
        slug: 'transactions',
        path: '/transactions',
        pathType: 'internal',
        pill: {},
        media: {},
        description: '',
        requiresPermission: {
          resource: 'payments',
          action: 'read',
        },
      },
      {
        label: 'Riders',
        slug: 'riders',
        path: '/riders',
        pathType: 'internal',
        pill: {},
        media: {},
        description: '',
        requiresPermission: {
          resource: 'riders',
          action: 'read',
        },
      },
    ],
  },
  {
    label: 'Inventory',
    slug: 'inventory',
    path: '#',
    pathType: 'internal',
    pill: {},
    media: {},
    description: '',
    hasSubMenu: true,
    subMenu: [
      {
        label: 'Inventory',
        slug: 'inventory',
        path: '/inventory',
        pathType: 'internal',
        pill: {},
        media: {},
        description: '',
        requiresPermission: {
          resource: 'inventory',
          action: 'read',
        },
      },
      {
        label: 'Purchase Requisitions',
        slug: 'requisition',
        path: '/requisition',
        pathType: 'internal',
        pill: {},
        media: {},
        description: '',
        requiresPermission: {
          resource: 'purchase_requisitions',
          action: 'read',
        },
      },
      {
        label: 'Purchase Orders',
        slug: 'purchase-orders',
        path: '/purchase-orders',
        pathType: 'internal',
        pill: {},
        media: {},
        description: '',
        requiresPermission: {
          resource: 'purchase_orders',
          action: 'read',
        },
      },
      {
        label: 'Sourcing Regions',
        slug: 'regions',
        path: '/regions',
        pathType: 'internal',
        pill: {},
        media: {},
        description: '',
        requiresPermission: {
          resource: 'regions',
          action: 'read',
        },
      },
      {
        label: 'Suppliers',
        slug: 'suppliers',
        path: '/suppliers',
        pathType: 'internal',
        pill: {},
        media: {},
        description: '',
        requiresPermission: {
          resource: 'suppliers',
          action: 'read',
        },
      },
    ],
  },
  {
    label: 'Users',
    slug: 'users',
    path: '/users',
    pathType: 'internal',
    pill: {},
    media: {},
    description: '',
    requiresPermission: {
      resource: 'users',
      action: 'read',
    },
  },
  {
    label: 'Reports & Analytics',
    slug: 'reports',
    path: '/reports',
    pathType: 'internal',
    pill: {},
    media: {},
    description: '',
    requiresPermission: {
      resource: 'reports',
      action: 'read',
    },
  },
];
